import { STATE, GETTERS } from "./names";

export default {
    [GETTERS.BUY_AUTOSHIP_DATA]: state => state[STATE.BUY_AUTOSHIP_DATA],
};
